import { CButton, CCard, CCardBody, CCardHeader, CCardTitle, CCol, CRow } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import Form from './Form'
import { useNavigate } from 'react-router-dom'
import DataTable from '../../widgets/DataTables/DataTable'
import RowCount from '../../widgets/DataTables/RowCount'
import CIcon from '@coreui/icons-react'
import { cilFile, cilList, cilPencil, cilTrash } from '@coreui/icons'
import BaseListing from 'src/BaseListings'
import getColumnSearchProps, { getCheckboxFilterProps, getDropdownSearchProps } from 'src/widgets/Filters/ColumnSearch'
import { wtHrefHashGetVars } from 'src/helpers/commons/HrefHash'
import { EmployeeForm } from '../../PDF/EmployeeForm'
import { generateallPDF } from 'src/PDF/allEmployeesForm'
import HrDigitalizationPDF from '../../PDF/HrDigitalization'
import { wtGetDateMonthYearFormat } from 'src/helpers/commons/moment'
import { EmployeeBlankForm } from '../../PDF/EmployeeBlankForm'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'


const RESIGNATION_STATUS_ACTIVE = 0;
const RESIGNATION_STATUS_RESIGNED = 1;
const RESIGNATION_STATUS_TERMINATE = 2;
const RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT = 3;
const RESIGNATION_STATUS_RETIREMENT = 4;
const RESIGNATION_STATUS_IN_SERVICE_DEATH = 5;
const RESIGNATION_STATUS_REPATRIATION = 6;

const RESIGNATION_STATUS_NAME = {
  0: 'Active',
  1: 'Resigned',
  2: 'Terminated',
  3: 'Contract Discontinued',
  4: 'Retired',
  5: 'Passed Away',
  6: 'Repatriation',
};

const RESIGNATION_STATUS_DROPDOWN_OPTIONS = [
  { value: RESIGNATION_STATUS_ACTIVE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_ACTIVE] },
  { value: RESIGNATION_STATUS_RESIGNED, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RESIGNED] },
  { value: RESIGNATION_STATUS_TERMINATE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_TERMINATE] },
  { value: RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT] },
  { value: RESIGNATION_STATUS_RETIREMENT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RETIREMENT] },
  { value: RESIGNATION_STATUS_IN_SERVICE_DEATH, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_IN_SERVICE_DEATH] },
  { value: RESIGNATION_STATUS_REPATRIATION, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_REPATRIATION] },
];


export const EMPLOYEE_TYPE_OFFICER = 1;
export const EMPLOYEE_TYPE_STAFF = 2;
export const EMPLOYEE_TYPE_WORKER = 3;

export const EMPLOYEE_TYPE_NAME = {
  1: 'Officer',
  2: 'Staff',
  3: 'Worker'
};

export const EMPLOYEE_TYPE_DROPDOWN_OPTIONS = [
  { value: EMPLOYEE_TYPE_OFFICER, label: EMPLOYEE_TYPE_NAME[EMPLOYEE_TYPE_OFFICER] },
  { value: EMPLOYEE_TYPE_STAFF, label: EMPLOYEE_TYPE_NAME[EMPLOYEE_TYPE_STAFF] },
  { value: EMPLOYEE_TYPE_WORKER, label: EMPLOYEE_TYPE_NAME[EMPLOYEE_TYPE_WORKER] },
];


// const JOB_TYPE_ACTIVE = "Active";
const JOB_TYPE_REGULAR = "Regular";
const JOB_TYPE_CONTRACTUAL = "Trainee";
const JOB_TYPE_DEPUTATIONIST = "Inactive";
const JOB_TYPE_DAILY_WAGER = "Daily Wager";

const JOB_TYPE_NAME = {
  // [JOB_TYPE_ACTIVE]: 'Active',
  [JOB_TYPE_REGULAR]: 'Regular',
  [JOB_TYPE_CONTRACTUAL]: 'Contractual',
  [JOB_TYPE_DEPUTATIONIST]: 'Deputationist',
  [JOB_TYPE_DAILY_WAGER]: 'Daily Wager',
};

const JOB_TYPE_DROPDOWN_OPTIONS = [
  // { value: JOB_TYPE_ACTIVE, label: JOB_TYPE_NAME[JOB_TYPE_ACTIVE] },
  { value: JOB_TYPE_REGULAR, label: JOB_TYPE_NAME[JOB_TYPE_REGULAR] },
  { value: JOB_TYPE_CONTRACTUAL, label: JOB_TYPE_NAME[JOB_TYPE_CONTRACTUAL] },
  { value: JOB_TYPE_DEPUTATIONIST, label: JOB_TYPE_NAME[JOB_TYPE_DEPUTATIONIST] },
  { value: JOB_TYPE_DAILY_WAGER, label: JOB_TYPE_NAME[JOB_TYPE_DAILY_WAGER] },
];



export default function Employees() {
  const [params, setParams] = useState({ isAdding: false, viewId: 0, editId: 0 })
  const Base = new BaseListing('employees', params)
  const hash = wtHrefHashGetVars()
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState([])
  const [branches, setBranches] = useState([])
  const [filterBranchId, setFilterBranchId] = useState(0)
  const [filterBranchName, setFilterBranchName] = useState('')
  const [filterID, setFilterID] = useState('')
  const [filterPersonalFileNo, setFilterPersonalFileNo] = useState('')
  const [departments, setDepartments] = useState([])
  const [filterDepartmentId, setFilterDepartmentId] = useState(0)
  const [filterDepartmentName, setFilterDepartmentName] = useState('')
  const [designations, setDesignations] = useState([])
  const [filterDesignationId, setFilterDesignationId] = useState(0)
  const [filterDesignationName, setFilterDesignationName] = useState('')
  const [filterEmployeeName, setFilterEmployeeName] = useState('')
  const [filterMobileNo, setFilterMobileNo] = useState('')
  const [filterDateOfJoining, setFilterDateOfJoining] = useState('')
  const [filterJobStatus, setFilterJobStatus] = useState([])
  const [filterResignationStatus, setFilterResignationStatus] = useState('')
  const [filterCnic, setFilterCnic] = useState('')
  const [displayFromCount, setDisplayFromCount] = useState(0)
  const [displayToCount, setDisplayToCount] = useState(0)
  const [totalRecords, setTotalRecords] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const defaultBranch = wtGetFromLocalStorage("default_branch_id");
  const [projects, setProjects] = useState([])
  const [FilterPlNumber, setFilterPlNumber] = useState('')

  const navigate = useNavigate()

  const onClose = () => {
    Base.setHashAction({}, (value) => setParams(value))
    getData()
  }

  const changeValues = (key, val) => {
    if (key === 'branch_id') {
      setFilterBranchId(val.value)
      setFilterBranchName(val.label)
      getDepartmentDropdown(val.value)
    }

    if (key === 'department_id') {
      setFilterDepartmentId(val.value)
      setFilterDepartmentName(val.label)
    }
    if (key === 'designation_id') {
      setFilterDesignationId(val.value)
      setFilterDesignationName(val.label)
    }
    if (key === 'resignation_status') {
      setFilterResignationStatus(val.value)
    }
    if (key === 'status') {
      setFilterJobStatus(val)
    }

  }


  const employeeblankform = () => {
    EmployeeBlankForm();
  }

  //handling pagination and sorting
  const onTableChange = (pagination, filter, sorter) => {
    const current_page = pagination.current
    const Size = pagination.pageSize
    setPageSize(Size)
    setCurrentPage(current_page)
    getData(current_page, Size, sorter)
  }

  const getReportData = (employee_id) => {
    wtApiCall(
      'employees/' + employee_id,
      {},
      'get',
      (response) => {
        const { data } = response
        EmployeeForm(data)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }

  const generateallPDF1 = (page = '', size = '', sorter = {}) => {
    const pageIndex = typeof page === 'number' ? page : parseInt(page, 10) || currentPage

    wtApiCall(
      'allemployees/',
      {
        _page_index: pageIndex,
        _page_size: size ? size : pageSize,
        _sort_order: sorter ? sorter : [],
        employee_name: filterEmployeeName,
        branch_id: filterBranchId,
        department_id: filterDepartmentId,
        designation_id: filterDesignationId,
        mobile_no: filterMobileNo,
        date_of_joining: filterDateOfJoining,
        cnic: filterCnic,
        job_status: filterJobStatus,
        id: filterID,
        personal_file_no: filterPersonalFileNo,
      },
      'get',
      (response) => {
        // const { data } = response
        generateallPDF(response.data.data)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }
  const generateCoverLetter = (page = '', size = '', sorter = {}) => {
    const pageIndex = typeof page === 'number' ? page : parseInt(page, 10) || currentPage

    wtApiCall(
      'allemployees/',
      {
        _page_index: pageIndex,
        _page_size: size ? size : pageSize,
        _sort_order: sorter ? sorter : [],
        employee_name: filterEmployeeName,
        branch_id: filterBranchId,
        department_id: filterDepartmentId,
        designation_id: filterDesignationId,
        mobile_no: filterMobileNo,
        date_of_joining: filterDateOfJoining,
        cnic: filterCnic,
        job_status: filterJobStatus,
        id: filterID,
        personal_file_no: filterPersonalFileNo,
      },
      'get',
      (response) => {
        // const { data } = response
        HrDigitalizationPDF(response.data.data)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }
  const getData = (page = '', size = '', sorter = {}) => {
    setIsLoading(true)
    wtApiCall(
      'employees',
      {
        _page_index: page ? page : currentPage,
        _page_size: size ? size : pageSize,
        _sort_order: sorter ? sorter : [],
        employee_name: filterEmployeeName,
        branch_id: filterBranchId,
        department_id: filterDepartmentId,
        designation_id: filterDesignationId,
        mobile_no: filterMobileNo,
        date_of_joining: filterDateOfJoining,
        cnic: filterCnic,
        job_status: filterJobStatus,
        id: filterID,
        personal_file_no: filterPersonalFileNo,
        resignation_status: filterResignationStatus,
        pl_number: FilterPlNumber
      },
      'get',
      (response) => {
        setData(response.data.data)
        setTotalRecords(response.data.total)
        setDisplayFromCount(response.data.from)
        setDisplayToCount(response.data.to)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }

  // data Table columns
  const columns = [
    {
      key: 'id',
      title: () => {
        return (
          <div>
            ID
            {filterID && (
              <>
                <br></br>
                <span style={{ color: 'blue' }}>
                  Filtering:<span style={{ color: 'green' }}>"{filterID}"</span>
                </span>
              </>
            )}
          </div>
        )
      },
      dataIndex: 'id',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      defaultSortOrder: 'descend',
      render: (text, record) => (
        <span
          style={{ color: 'blue', cursor: 'pointer' }}
          onClick={() => navigate({ pathname: '/employee-profile', search: `?id=${record.id}` })}
        >
          {text}
        </span>
      ),
      ...getColumnSearchProps('id', filterID, setFilterID, getData),
    },

    {
      key: 'personal_file_no',
      title: () => {
        return (
          <div>
            Personal File No
            {filterPersonalFileNo && (
              <>
                <br></br>
                <span style={{ color: 'blue' }}>
                  Filtering:<span style={{ color: 'green' }}>"{filterPersonalFileNo}"</span>
                </span>
              </>
            )}
          </div>
        )
      },
      dataIndex: 'personal_file_no',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (text, record) => (
        <span
          style={{ color: 'blue', cursor: 'pointer' }}
          onClick={() => navigate({ pathname: '/employee-profile', search: `?id=${record.id}` })}
        >
          {text}
        </span>
      ),
      ...getColumnSearchProps(
        'personal_file_no',
        filterPersonalFileNo,
        setFilterPersonalFileNo,
        getData,
      ),
    },
    {
      key: 'pl_number',
      title: () => {
        return (
          <div>
            PL Number
            {FilterPlNumber && (
              <>
                <br></br>
                <span style={{ color: 'blue' }}>
                  Filtering:<span style={{ color: 'green' }}>"{FilterPlNumber}"</span>
                </span>
              </>
            )}
          </div>
        )
      },
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (record) => record.pl_number,
      width: '10%',
      ...getColumnSearchProps(
        'pl_number',
        FilterPlNumber,
        setFilterPlNumber,
        getData,
      ),
    },
    {
      key: 'full_name',
      title: () => {
        return (
          <div>
            Full Name
            {filterEmployeeName && (
              <>
                <br></br>
                <span style={{ color: 'blue' }}>
                  Filtering:<span style={{ color: 'green' }}>"{filterEmployeeName}"</span>
                </span>
              </>
            )}
          </div>
        )
      },
      dataIndex: 'full_name',
      render: (text, record) => (
        <span
          style={{ color: 'blue', cursor: 'pointer' }}
          onClick={() => navigate({ pathname: '/employee-profile', search: `?id=${record.id}` })}
        >
          {text}
        </span>
      ),
      ...getColumnSearchProps('full_name', filterEmployeeName, setFilterEmployeeName, getData),
    },
    {
      key: 'designation_id',
      title: () => {
        return (
          <div>
            Designation
            {filterDesignationName && (
              <>
                <br></br>
                <span style={{ color: 'blue' }}>
                  Filtering:<span style={{ color: 'green' }}>"{filterDesignationName}"</span>
                </span>
              </>
            )}
          </div>
        )
      },
      render: (record) => record.designation.name,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      ...getDropdownSearchProps(
        'designation_id',
        designations,
        changeValues,
        'Select Designation',
        getData,
      ),
    },
    {
      key: 'department_id',
      title: () => {
        return (
          <div>
            Department
            {filterDepartmentName && (
              <>
                <br></br>
                <span style={{ color: 'blue' }}>
                  Filtering:<span style={{ color: 'green' }}>"{filterDepartmentName}"</span>
                </span>
              </>
            )}
          </div>
        )
      },
      render: (record) => record.department.name,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      ...getDropdownSearchProps(
        'department_id',
        departments,
        changeValues,
        'Select Department',
        getData,
      ),
    },

    // {
    //   key: 'mobile_no',
    //   title: () => {
    //     return (
    //       <div>
    //         Mobile no.
    //         {filterMobileNo && (
    //           <>
    //             <br></br>
    //             <span style={{ color: 'blue' }}>
    //               Filtering:<span style={{ color: 'green' }}>"{filterMobileNo}"</span>
    //             </span>
    //           </>
    //         )}
    //       </div>
    //     )
    //   },
    //   dataIndex: 'mobile_no',
    //   sorter: true,
    //   sortDirections: ['ascend', 'descend'],
    //   ...getColumnSearchProps('mobile_no', filterMobileNo, setFilterMobileNo, getData),
    // },
    {
      key: 'cnic',
      title: () => {
        return (
          <div>
            CNIC
            {filterCnic && (
              <>
                <br></br>
                <span style={{ color: 'blue' }}>
                  Filtering:<span style={{ color: 'green' }}>"{filterCnic}"</span>
                </span>
              </>
            )}
          </div>
        )
      },
      dataIndex: 'cnic',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      ...getColumnSearchProps('cnic', filterCnic, setFilterCnic, getData),
    },

    {
      key: 'date_of_joining',
      title: () => {
        return (
          <div>
            Date Of Joining
            {filterDateOfJoining && (
              <>
                <br></br>
                <span style={{ color: 'blue' }}>
                  Filtering:<span style={{ color: 'green' }}>"{filterDateOfJoining}"</span>
                </span>
              </>
            )}
          </div>
        )
      },
      dataIndex: 'date_of_joining',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (text) => {
        return <span style={{ color: 'blue' }}>{wtGetDateMonthYearFormat(text)}</span>
      },
      ...getColumnSearchProps(
        'date_of_joining',
        filterDateOfJoining,
        setFilterDateOfJoining,
        getData,
      ),
    },

    {
      key: 'duration',
      title: 'Duration',
      dataIndex: 'duration',
      render: (text) => {
        return <span style={{ color: 'red' }}>{text}</span>
      },
    },
    {
      key: 'age',
      title: 'Age',
      dataIndex: 'age',
      render: (text) => {
        return <span style={{ color: 'green' }}>{text}</span>
      },
    },
    {
      key: 'job_status',
      title: () => {
        return (
          <div>
            Job Status
            {filterJobStatus.length > 0 && (
              <>
                <br></br>
                <span style={{ color: 'green' }}>
                  "{filterJobStatus.map((item) => JOB_TYPE_NAME[item] + ',')}"
                </span>
              </>
            )}
          </div>
        )
      },
      dataIndex: 'job_status',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (text, item) => {
        return (
          <span className={text === 'Inactive' ? 'badge bg-secondary' : 'badge bg-primary'}>
            {text}
          </span>
        )
      },
      ...getCheckboxFilterProps(
        'status',
        JOB_TYPE_DROPDOWN_OPTIONS,
        filterJobStatus,
        changeValues,
        getData,
      ),
    },
    {
      key: 'resignation_status',
      title: () => {
        return (
          <div>
            Resignation Status
            {filterResignationStatus !== '' && (
              <>
                <br></br>
                <span style={{ color: 'blue' }}>
                  Filtering:<span style={{ color: 'green' }}>"{RESIGNATION_STATUS_NAME[filterResignationStatus]}"</span>
                </span>
              </>
            )}
          </div>
        )
      },
      dataIndex: 'resignation_status',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (text, record) => {
        return (
          <span className={record.resignation_status !== RESIGNATION_STATUS_ACTIVE ? 'badge bg-danger' : 'badge bg-primary'}>
            {RESIGNATION_STATUS_NAME[record.resignation_status]}
          </span>
        )
      },
      ...getDropdownSearchProps('resignation_status', RESIGNATION_STATUS_DROPDOWN_OPTIONS, changeValues, "Select Status", getData),
    },
    {
      key: 'action',
      title: 'Action',
      render: (record) => {
        return (
          <>
            {Base.hasRights('View Employees') && (
              <CButton
                className="text-white btn-sm"
                color="success"
                shape="rounded-pill"
                onClick={() =>
                  navigate({ pathname: '/employee-profile', search: `?id=${record.id}` })
                }
              >
                <CIcon icon={cilList} />
              </CButton>
            )}
            {Base.hasRights('Edit Employees') && (
              <CButton
                className="text-white btn-sm"
                color="primary"
                shape="rounded-pill"
                onClick={() =>
                  Base.setHashAction({ edit: record.id }, (value) =>
                    setParams((prev) => ({ ...prev, ...value })),
                  )
                }
              >
                <CIcon icon={cilPencil} />
              </CButton>
            )}
            {Base.hasRights('Delete Employees') && (
              <CButton
                className="text-white btn-sm"
                shape="rounded-pill"
                color="danger"
                onClick={() => Base.deleteData('employees', record.id, getData)}
              >
                <CIcon icon={cilTrash} />
              </CButton>
            )}
            {Base.hasRights('Print Employee Form') && (
              <CButton
                className="text-white btn-sm"
                color="danger"
                shape="rounded-pill"
                onClick={() => getReportData(record.id)}
              >
                <CIcon icon={cilFile} />
              </CButton>
            )}
          </>
        )
      },
    },
  ]

  useEffect(() => {
    Base.loadActionFromHash((value) => setParams(value))
    Base.dropdownData("departments", {}, [setDepartments], 1)
    Base.dropdownData("designations", {}, [setDesignations], 1)
    Base.dropdownData("projects", {}, [setProjects], 1)

    getData('', '', { order: 'descend', columnKey: 'id' })
  }, [])

  return (
    <>
      {params.isAdding && (
        <Form
          onClose={() => onClose()}
          projects={projects}
          reloadProjects={() => Base.dropdownData('projects', {}, [setProjects], 1)}
          editId={params.editId}
          departments={departments}
          designations={designations}
        />
      )}
      {params.editId > 0 && (
        <Form
          onClose={() => onClose()}
          projects={projects}
          reloadProjects={() => Base.dropdownData('projects', {}, [setProjects], 1)}
          editId={params.editId}
          departments={departments}
          designations={designations}
        />
      )}

      {!params.isAdding && params.editId == 0 && (
        <CRow>
          <CCol md="12">
            <CCard className="card-dark">
              <CCardHeader style={{ backgroundColor: '#3c4b64' }}>
                <CCardTitle className="text-white">Employee Details</CCardTitle>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  {/* <CCol md={3}>
                    <CFormInput
                      placeholder="Search Employee Name"
                      value={filterEmployeeName}
                      onChange={(ev) => setFilterEmployeeName(ev.target.value)}
                    />
                  </CCol>
                  <CCol md={3}>
                    <WidgetBranchSelector

                      displayValue={filterBranchName}
                      value={filterBranchId}
                      placeholder="Select Branch"
                      onChange={(values) => changeValues('branch_id', values)}
                      reloadDropdownData={() => Base.dropdownData('branches', {}, [setBranches], 1)}
                    />
                  </CCol>
                  <CCol md={3}>
                    <WidgetDepartmentSelector
                      departments={departments}
                      displayValue={filterDepartmentName}
                      value={filterDepartmentId}
                      placeholder="Select Department"
                      onChange={(values) => changeValues('department_id', values)}
                      reloadDropdownData={() => getDepartmentDropdown(filterBranchId)}
                    />
                  </CCol> */}
                  <CCol md={12}>
                    {/* <CButton
                      color="warning"
                      className="text-white"
                      onClick={() => setIsMore(!isMore)}
                    >
                      More
                    </CButton>
                    <CButton color="primary" onClick={() => getData()} style={{ marginLeft: '1%' }}>
                      Search
                    </CButton> */}
                    {/* <CButton
                      color="danger"
                      className="text-white"
                      style={{ marginLeft: '86%' }}
                      onClick={getReportData}
                    >
                      PDF
                    </CButton> */}

                    {Base.hasRights('Add Employees') && defaultBranch !== 0 && (
                      <CButton
                        color="success"
                        className="text-white"
                        style={{ float: 'right' }}
                        onClick={() =>
                          Base.setHashAction({ add: 1 }, (value) =>
                            setParams((prev) => ({ ...prev, ...value })),
                          )
                        }
                      >
                        Add New
                      </CButton>
                    )}
                    {Base.hasRights('Print ALL Employee PDF Form') && (
                      <>
                        <CButton
                          color="danger"
                          className="text-white mx-2"
                          style={{ float: 'right' }}
                          onClick={generateallPDF1}
                        >
                          Genrate PDF
                        </CButton>
                        <CButton
                          color="info"
                          className="text-white mx-2"
                          style={{ float: 'right' }}
                          onClick={generateCoverLetter}
                        >
                          HR Digitalization
                        </CButton>
                      </>
                    )}
                    <CButton
                      color="dark"
                      className="text-white mx-2"
                      style={{ float: 'right' }}
                      onClick={employeeblankform}
                    >
                      Employee Form
                    </CButton>

                  </CCol>
                </CRow>
                {/* {isMore && (
                  <>
                    <br />
                    <CRow>
                      <CCol md={3}>
                        <WidgetDesignationSelector
                          designations={designations}
                          displayValue={filterDesignationName}
                          value={filterDesignationId}
                          placeholder="Select Designation"
                          onChange={(values) => changeValues('designation_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('designations', {}, [setDesignations], 1)
                          }
                        />
                      </CCol>
                      <CCol md={2}>
                        <CFormInput
                          placeholder="Search Mobile no"
                          value={filterMobileNo}
                          onChange={(ev) => setFilterMobileNo(ev.target.value)}
                        />
                      </CCol>
                      <CCol md={2}>
                        <WidgetDatePicker
                          value={filterDateOfJoining}
                          setDate={setFilterDateOfJoining}
                          placeholder="Select Date of Joining"
                        />
                      </CCol>
                      <CCol md={2}>
                        <CFormInput
                          placeholder="Search CNIC"
                          value={filterCnic}
                          onChange={(ev) => setFilterCnic(ev.target.value)}
                        />
                      </CCol>
                    </CRow>
                  </>
                )} */}
                <br />
                <DataTable
                  data={data}
                  columns={columns}
                  pageSize={pageSize}
                  totalRecords={totalRecords}
                  onTableChange={onTableChange}
                  isLoading={isLoading}
                  currentPage={currentPage}
                />
                <RowCount
                  displayFromCount={displayFromCount}
                  displayToCount={displayToCount}
                  totalRecords={totalRecords}
                />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      )}
    </>
  )
}
